import { render, staticRenderFns } from "./content-after-buy.vue?vue&type=template&id=0ccb36c8&scoped=true&"
import script from "./content-after-buy.vue?vue&type=script&lang=ts&"
export * from "./content-after-buy.vue?vue&type=script&lang=ts&"
import style0 from "./content-after-buy.vue?vue&type=style&index=0&id=0ccb36c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccb36c8",
  null
  
)

export default component.exports